import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServiceDetailsPage() {
  pageTitle('UI/UX Designing');
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <PageHeading
        title='UI/UX Designing'
        bgSrc='/images/service_hero_bg.jpeg'
        pageLinkText={'UI/UX Designing'}
      />

      <Spacing lg='145' md='80' />

      {/* Introduction Section */}
      <Div className="container">
        <SectionHeading
          title='Intuitive UI/UX Design Services'
          subtitle='Design That Delivers Impactful Digital Experiences'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <p className='cs-text_large text-center'>
          At Dappster Studio, we design human-centered interfaces and seamless user experiences that drive engagement, retention, and conversions. Our UI/UX solutions are tailored to align with your brand identity, audience behavior, and business goals.
        </p>
        <Spacing lg='20' md='15' />
        <p className='cs-text_large text-center'>
          From wireframes to interactive prototypes, we use industry-leading tools like Figma, Adobe XD, Sketch, and InVision to craft elegant, responsive, and conversion-driven digital products for web and mobile platforms.
        </p>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Services Section */}
      <Div className="container">
        <SectionHeading
          title='Our UI/UX Design Services'
          subtitle='Crafting Seamless, Aesthetic & Functional Experiences'
          variant='cs-style1 text-center'
        />
        <Spacing lg='90' md='45' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_1.svg'
              title='UI Design'
              subtitle='Modern, clean interfaces for web and mobile apps that reflect your brand’s identity.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_2.svg'
              title='UX Research & Strategy'
              subtitle='In-depth user research, persona creation, and journey mapping to guide design decisions.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_3.svg'
              title='Wireframing & Prototyping'
              subtitle='Low- to high-fidelity wireframes and clickable prototypes to test ideas quickly.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_4.svg'
              title='Mobile App Design'
              subtitle='Pixel-perfect UI for iOS and Android apps with optimal usability and navigation.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_5.svg'
              title='Website & Dashboard Design'
              subtitle='Responsive, intuitive dashboards and web designs that scale across all devices.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_6.svg'
              title='UI/UX Audits & Redesign'
              subtitle='Evaluate and revamp existing products to improve usability, clarity, and flow.'
            />
            <Spacing lg='30' md='30' />
          </Div>
        </Div>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Industries Section */}
      <Div className="container">
        <SectionHeading
          title='Industries We Design For'
          subtitle='Designing with Purpose Across Diverse Sectors'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/app-icon.svg'
              title='SaaS & Enterprise Software'
              subtitle='Intuitive dashboard and user flows for B2B & SaaS platforms.'
            />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/cart-icon.svg'
              title='E-Commerce & Retail'
              subtitle='Conversion-optimized interfaces that enhance shopping experiences.'
            />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/money-icon.svg'
              title='Fintech & Banking'
              subtitle='Clean, secure, and user-friendly design for financial platforms.'
            />
          </Div>
        </Div>
        <Div className="row mt-lg-5" > 
          <Div className="col-lg-6">
            <IconBox
              icon='/images/icons/healthcare-icon.svg'
              title='Healthcare & Wellness'
              subtitle='Accessible and empathetic design for health-tech and wellness apps.'
            />
          </Div>
          <Div className="col-lg-6">
            <IconBox
              icon='/images/icons/education-icon.svg'
              title='Education & eLearning'
              subtitle='Interactive design for digital classrooms, LMS, and knowledge platforms.'
            />
          </Div>
        </Div>
      </Div>

      <Spacing lg='150' md='80' />
    </>
  )
}
